export const AGGREGATOR_TYPE_BADGE = {
  STANDARD: { text: 'Standard', color: 'success' },
  GENERIC: { text: 'Generic', color: 'primary' },
  NO_EMPLOYER: { text: 'No employer', color: 'warning' },
  INTERNAL: { text: 'Internal', color: 'secondary' },
};

export const AGGREGATOR_FINCH_CONNECTION_BADGE = {
  connected: { text: 'Connected', color: 'bg-success' },
  pending: { text: 'Pending', color: 'bg-primary' },
  error_no_account_setup: { text: 'Error No Account Setup', color: 'bg-danger' },
  error_permissions: { text: 'Error Permissions', color: 'bg-danger' },
  reauth: { text: 'Reauth', color: 'bo-bg-orange' },
  processing: { text: 'Processing', color: 'bg-warning' },
};
